import axiosClient from '@/api/axiosClient';
import { API_GET_LOGIN_USER, API_LOGIN } from '@/config/paths/API_PATH';

async function signIn(data) {
  const res = await axiosClient.post(API_LOGIN, data);

  return res.data;
}

async function getSignInUser() {
  const response = await axiosClient.get(API_GET_LOGIN_USER);

  return response;
}

function getCurrentUser() {
  return JSON.parse(localStorage.getItem('user') || '{}');
}

export { signIn, getSignInUser, getCurrentUser };
